import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import ActionButton, { SecondaryButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer';
import Model from '../builder/Model';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle.js';
import Spinner from '../builder/Spinner.js';
import Select from '../builder/Select.js';

import { AlertMessage } from '../builder/Message.js';
import { useAccount } from '../context/accountContext.js';

const AICrosswordsDefinitionGenerator = (props) => {
	const { MyAccount } = useAccount();
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promotion = props?.promotion ?? {};

	const getLangName = (lang) => {
		if(window.locales == undefined) return "Not defined";

		const lang_name = window.locales[lang];
		if(lang_name != undefined) return lang_name;

		return "Not defined";
	};

	const allowed_locales = ['eng',
							'en-us',
							'en-gb',
							'spa',
							'es-es',
							'cat',
							'glg',
							'deu',
							'fre',
							'ita',
							'por',
							'pt-br',
							'cze',
							'fin',
							'slv',
							'dan',
							'dut',
							'swe',
							'nor',
							'baq',
							'hun',
							'slo',
							'hrv',
							'rum',
							'bos',
						];
	const available_langs_to_add = [];
	//EXTRA LANGUAGES
	(window?.promoLocales ?? []).filter(item => allowed_locales.includes(item.I18nPromotion.lang)).map((lang) => {
		available_langs_to_add.push({ k:lang.I18nPromotion.lang, v:getLangName(lang.I18nPromotion.lang) });
	});
	//MAIN PROMOLANG
	if(allowed_locales.includes(promotion?.default_locale ?? 'eng')){
		available_langs_to_add.unshift({ k:promotion?.default_locale ?? 'eng', v:getLangName(promotion?.default_locale ?? 'eng') });
	}
	//NOT ALLOWED MAIN PROMOLANG + NO ALLOWED EXTRA LANGUAGES
	if(available_langs_to_add.length == 0){
		const agent_locale = (MyAccount.getAgentLang() == 'es') ? 'spa' : 'eng';
		available_langs_to_add.unshift({ k:agent_locale, v:getLangName(agent_locale) });
	}

	const promotion_id = promotion?.id ?? false;
	const default_ai = {
		language:available_langs_to_add[0].k,
		model:'gpt-3.5-turbo',
		type:'crosswords_definition',
	};

	const [ ai, setAi ] = useState(default_ai);
	const [ searchingAI, setSearchingAI ] = useState(false);
	const [ api_error, setApiError ] = useState(false);

	if(promotion_id === false) return null;

	const close = () => {
		if(props.close != undefined) props.close();
	};

	const change = (k, v) => {
		setAi({ ...ai, [k]:v });
	};

	const searchAI = (cb) => {
		setSearchingAI(true);
		const type = 'ai_crosswords_definition';

		$.post({
			url:getRemotedbUrl(`/promotions/search_ai/${promotion_id}`),
			data:{ ...ai, ...{'word':props.model.word} },
			dataType:'JSON',
			success:(r) => {
				setSearchingAI(false);
				if(r.status == 1  && r.definition != undefined) {
					if(props.onSuccess) props.onSuccess(r.definition)
				} else {
					setApiError(true);
				}
			
				if(cb != undefined) cb();
			},
			error:(jqXHR, textStatus, errorThrown) => {
				// Handle error
				close();
				setSearchingAI(false);
				
				let track_data = {};
				track_data.error = `JS ERROR: ${errorThrown}`;
				track_data.ai = ai;
				$.post(`/sweeps/track_error_log/${type}/${promotion_id}`, track_data,'JSON');

				setApiError(true);
			}
		});
	};

	return (
		<FloatingLayer
			_class={{ size:'small'}}
			backButton={(!searchingAI) ? () => close() : null}
			enable_close={(!searchingAI) ? true : false}
		>
			<div>
				<SectionTitle
					autotranslate={false}
				>{props.intl.formatMessage({ id:"AI Generator: Definition for {word}." }, { word:`"${props.model.word}"` })}</SectionTitle>
				<SectionSubtitle>Generate a quick definition using Artificial Intelligence.</SectionSubtitle>

				{(api_error) ? (
					<AlertMessage>
						<p>{i18n("Error connecting to the AI, please try again in a few minutes, and if the problem persists, contact support.")}</p>
					</AlertMessage>
				) : (
					<Model model={ai} change={change}>
						<Select
							name="language"
							values={available_langs_to_add}
							_class={{ size:60 }}
						>Select a language</Select>
					</Model>
				)}

				{(searchingAI) && (
					<Spinner
						autotranslate={false}
						force_bg={true}
					>{`${i18n("AI in process, please wait. This could take a while")}...`}</Spinner>
				)}

				<ButtonCollection in_floating={true}>
					{(!api_error) && (
						<ActionButton
							onClick={() => searchAI()}
						>Generate definition</ActionButton>
					)}

					<SecondaryButton
						onClick={() => close()}
					>Close</SecondaryButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	);
}

export default injectIntl(AICrosswordsDefinitionGenerator);